import { AssessmentStepKeys } from '@/enums'
import { useTranslation } from 'react-i18next'
import { LeadGenerationAssessment } from './BasePage'

interface AddressMessages {
  city: string
  cityInfo: string
  postalCode: string
  postalCodeInfo: string
  street: string
  streetInfo: string
  streetNr: string
  streetNrInfo: string
}

interface ConstructionDate {
  [key: string]: any
}

interface ConstructionDetails {
  [key: string]: any
}

interface ConstructionArea {
  [key: string]: any
}

interface FormSteps {
  constructionDate: ConstructionDate
  constructionDetails: ConstructionDetails
  constructionArea: ConstructionArea
  [key: string]: any
}

interface TransformedSubmitValues {
  constructionDetails: ConstructionDate & ConstructionDetails & ConstructionArea
  [key: string]: any
}

type TransformSubmitValuesFunction = (
  values: FormSteps,
) => TransformedSubmitValues

const useMessages = (): AddressMessages => {
  const { t } = useTranslation()

  return {
    city: t('buildingCity'),
    cityInfo: t('buildingCityInfo'),
    postalCode: t('buildingPostalCode'),
    postalCodeInfo: t('buildingPostalCodeInfo'),
    street: t('buildingStreet'),
    streetInfo: t('buildingStreetInfo'),
    streetNr: t('buildingStreetNr'),
    streetNrInfo: t('buildingStreetNrInfo'),
  }
}

const buildingAssessmentSteps = [
  AssessmentStepKeys.businessType,
  AssessmentStepKeys.constructionDate,
  AssessmentStepKeys.constructionDetails,
  AssessmentStepKeys.constructionArea,
  AssessmentStepKeys.createLead,
]

const makeSubmitValues = ({
  constructionDate,
  constructionDetails,
  constructionArea,
  ...steps
}: FormSteps): TransformedSubmitValues => ({
  ...steps,
  constructionDetails: {
    ...constructionDate,
    ...constructionDetails,
    ...constructionArea,
  },
})

const makeStepProps = (
  addressMessages: AddressMessages,
  transformSubmitValues: TransformSubmitValuesFunction,
) => ({
  [AssessmentStepKeys.createLead]: {
    categoryId: 'BU',
    transformSubmitValues,
    addressMessages,
    show: {
      postalCode: true,
      street: true,
      streetNr: true,
      city: true,
    },
  },
})

export const BuildingLead = () => {
  const messages = useMessages()

  return (
    <LeadGenerationAssessment
      categoryId="BU"
      stepProps={makeStepProps(messages, makeSubmitValues)}
      stepKeys={buildingAssessmentSteps}
    />
  )
}
